export default __webpack_public_path__ + "static/media/lis-logo.ca19e50d.png";